// Utils
import { routes } from '@routes';

// UI
import { Avatar } from '@components/avatar';
import { Typography } from '@components/typography';

type Props = {
  listingType?: string;
  listingDetails: {
    bedrooms?: number;
    baths?: number;
    capacity?: number;
  };
  account: {
    id: string;
    slug?: string;
    companyName?: string | undefined;
    avatarUrl?: string | undefined;
    marketingWebsiteUrl?: string | undefined;
  };
};

export const ListingCapacityDetails: React.FC<{
  bedrooms?: number;
  baths?: number;
  capacity?: number;
}> = ({ bedrooms, baths, capacity }) => {
  if (capacity || bedrooms || baths) {
    return (
      <ul className="w-full flex space-x-1 sm:space-x-2 items-center whitespace-nowrap">
        {capacity && (
          <li>
            <Typography variant="small" variantM="body2" component="span">
              {capacity} guests
            </Typography>
          </li>
        )}
        {capacity && (bedrooms !== undefined && bedrooms > 0) && (
          <Typography variant="small" variantM="body2" component="span">
            |
          </Typography>
        )}
        {bedrooms !== undefined && bedrooms > 0 && (
          <li>
            <Typography variant="small" variantM="body2" component="span">
              {bedrooms} bedrooms
            </Typography>
          </li>
        )}
        {baths !== undefined && baths > 0 && (
          <Typography variant="small" variantM="body2" component="span">
            |
          </Typography>
        )}
        {baths !== undefined && baths > 0 && (
          <li>
            <Typography variant="small" variantM="body2" component="span">
              {baths} baths
            </Typography>
          </li>
        )}
      </ul>
    );
  }
  return null;
};

export const ManagementBio: React.FC<Props> = ({
  listingType,
  account,
  listingDetails,
}) => {
  if (account.avatarUrl) {
    return (
      <div className="-mt-2 sm:-mt-12">
        <div className="flex flex-row items-center justify-between space-x-8">
          <div className="space-y-1 justify-between">
            <Typography component="h4" variant="title5" variantM="title4">
              {account.companyName && listingType
                ? `${listingType} hosted by ${account.companyName}`
                : listingType}
            </Typography>
            <ListingCapacityDetails
              bedrooms={listingDetails.bedrooms}
              baths={listingDetails.baths}
              capacity={listingDetails.capacity}
            />
          </div>
          <div className="relative w-[72px] h-[72px] overflow-hidden flex-shrink-0 rounded-full shadow-lg">
            {account.slug && (
              <Avatar
                firstName={account.companyName}
                shape="circle"
                avatarUrl={account.avatarUrl}
                linkTo={routes.accounts(account.slug)}
              />
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex flex-col">
        <Typography component="h4" variant="title5" variantM="title4">
          {account.companyName && listingType
            ? `${listingType} hosted by ${account.companyName}`
            : listingType}
        </Typography>
        <ListingCapacityDetails
          bedrooms={listingDetails.bedrooms}
          baths={listingDetails.baths}
          capacity={listingDetails.capacity}
        />
      </div>
    );
  }
};
